import React from "react";
import {ClipLoader} from "react-spinners";
import MyWorkShopFilters from "./MyWorkShopFilters";
import MyOnlineWorkshopsCert from "./MyOnlineWorkshopsCert";
import OrganizationFilter from './OrganizationsFilter';
import SearchField from "./SearchField";
import HttpClient from "services/HttpClient";
import OnlineWorkShop from "./OnlineWorkShop";
import { withRouter } from "react-router-dom";
import { StickyContainer, Sticky } from "react-sticky";
import Modal from "react-modal";

import {
  PROVIDER_MY_WORKSHOP_TYPE,
  ONLINE_WORKSHOPS_TYPE,
  REGULAR_WORKSHOPS
} from "stores/WorkshopsUrlConstants";
import { inject, observer } from "mobx-react";
import "styles/css/pagination.scss";
import Pagination from "./Pagination";
import RegularWorkshop from "./RegularWorkshop";
import _ from "lodash";
import EMPTY from "styles/img/empty_results.svg";
const GET_MY_WORKSHOPS = "/api/v1/workshops/my/?";
const ONLINE_WORKSHOPS = "/api/v1/workshops/online/?";
const REGULAR_WORKSHOPS_API = "/api/v1/workshops/in_person/?";
const DELETE = "/api/v1/workshops/";
const APPROVE_URL = "/api/v1/workshops/to_review/?";
const APPROVE_MODULES = "/api/v1/workshops/to_review/?add_modules=false&";

@inject("searchFieldEventEmitter")
@inject("alert", "modal", 'filter', 'user')
@observer
class MyWorkshops extends React.Component {
  state = {
    workshops: [],
    title: "",
    type: null,
    pagesCount: 0,
    defaultPrefix: "MY",
    modalOpened: false,
    delelteObject: null,
    pathname: '',
    hideFilter: false,
    showLiveBanner: true,
    showOnlineBanner: true,
    showGroupBanner: true,
    showOrgBanner: true,
    showPublicBanner: true,
    isLoading: false,
    // workshopsUpated: false
  };

  componentWillMount = () => {
    this.initialize(this.props.location.pathname);
    this.onStartFunction();
    this.routerListn();
  };

  onStartFunction = () => {
    this.props.searchFieldEventEmitter.setInitialState();
    this.props.searchFieldEventEmitter.allowRAP();
    // this.initialize(this.props.location.pathname);
  };

  routerListn = () => {
    const myWorkshopPaths = [
      '/online_workshops',
      '/regular_workshops',
      '/provider_my_workshops',
      '/adminpanel/approve_workshop',
      '/adminpanel/approve_module'
    ];

    this.routerListener = this.props.history.listen((location, action) => {

      if (location.pathname !== this.state.pathname) {
        if (myWorkshopPaths.indexOf(location.pathname) > -1) {
          this.props.searchFieldEventEmitter.denyRAP();
          this.props.searchFieldEventEmitter.setInitialState();
          this.initialize(location.pathname);
        } else {
          this.props.searchFieldEventEmitter.denyRAP();
          this.props.searchFieldEventEmitter.setInitialState();
        }
      }

    });
  }

  loadNewByUrl = requestUrl => {
    this.setState({isLoading: true});
    let url = requestUrl;
    if (!requestUrl && this.props.location.search) {
      url = this.props.location.search.slice(1);

      // parse url for filter and page params on load
      var urlPage = url.match(/page=\d+/);
      if (urlPage) {
        this.props.searchFieldEventEmitter.denyRAP();
        var page = urlPage[0].slice(5)
        this.props.searchFieldEventEmitter.setPage(page);
        this.props.searchFieldEventEmitter.allowRAP();
      }
    }
    
    if (this.state.type === PROVIDER_MY_WORKSHOP_TYPE)
      new HttpClient().get(GET_MY_WORKSHOPS + url).then(response => {
        // console.log("url from GET_MY_WORKSHOPS", url);
        this.setState({
          workshops: response.body.data.workshops,
          count: response.body.data.count,
          pagesCount: response.body.data.pages,
          defaultPrefix: "MY ONLINE",
          isLoading: false,
        });
        window.scrollTo(0, 0);
        this.props.searchFieldEventEmitter.setTotalPages(
          response.body.data.pages
        );
      });
    if (this.state.type === ONLINE_WORKSHOPS_TYPE) {
      if((!url && this.props.location.state) || (this.props.location.state && url === '&page=1')) {
        if(this.props.location.state.webinar) url = 'workshop_types[]=2&page=1'
        if(this.props.location.state.online) url = 'workshop_types[]=1&page=1'
        if(this.props.location.state.group) url = 'workshop_types[]=3&page=1'
        if(this.props.location.state.organizations) url = 'workshop_types[]=4&page=1'
        if(this.props.location.state.public) url = 'workshop_types[]=5&page=1'
      }
      new HttpClient().get(ONLINE_WORKSHOPS + url).then(response => {
        // console.log("url from ONLINE_WORKSHOPS", url);
        this.setState({
          workshops: response.body.data.workshops,
          count: response.body.data.count,
          defaultPrefix: "ONLINE",
          isLoading: false,
        });
        window.scrollTo(0, 0);
        this.props.searchFieldEventEmitter.setTotalPages(
          response.body.data.pages
        );
      });
    }
    if (this.state.type === REGULAR_WORKSHOPS) {
      // console.log('url from REGULAR_WORKSHOPS =', url)
      if(this.props.filter.value.venue_county && !url){
        url = this.props.filter.url;
      }
      new HttpClient().get(REGULAR_WORKSHOPS_API + url).then(response => {
        // console.log('workshops =', response.body.data.workshops)
        this.setState({
          workshops: response.body.data.workshops,
          count: response.body.data.count,
          defaultPrefix: "REGULAR",
          isLoading: false,
        });
        //document.querySelector('.section-holder').scrollTop = 0;
        //document.querySelector('body').scrollTop = 0;
        window.scrollTo(0, 0);
        this.props.searchFieldEventEmitter.setTotalPages(
          response.body.data.pages
        );
      });
    }
    if (this.state.type === "APPROVE")
      new HttpClient().get(APPROVE_URL + url).then(response => {
        this.setState({
          workshops: response.body.data.workshops,
          count: response.body.data.count,
          defaultPrefix: "APPROVE",
          isLoading: false,
        });
        // document.querySelector('.section-holder').scrollTop = 0;
        // document.querySelector('body').scrollTop = 0;
        window.scrollTo(0, 0);
        this.props.searchFieldEventEmitter.setTotalPages(
          response.body.data.pages
        );
      });
    if (this.state.type === "APPROVE_MODULE")
      new HttpClient().get(APPROVE_MODULES + url).then(response => {
        this.setState({
          workshops: response.body.data.workshops,
          count: response.body.data.count,
          defaultPrefix: "APPROVE",
          isLoading: false,
        });
        // document.querySelector('.section-holder').scrollTop = 0;
        // document.querySelector('body').scrollTop = 0;
        window.scrollTo(0, 0);
        this.props.searchFieldEventEmitter.setTotalPages(
          response.body.data.pages
        );
      });
  };

  initialize = pathName => {
    this.props.searchFieldEventEmitter.allowRAP();
    let type;
    let hideFilter = false;
    this.props.searchFieldEventEmitter.handleReset();
    if (pathName.includes(PROVIDER_MY_WORKSHOP_TYPE))
      type = PROVIDER_MY_WORKSHOP_TYPE;
    if (pathName.includes(ONLINE_WORKSHOPS_TYPE)) type = ONLINE_WORKSHOPS_TYPE;
    if (pathName.includes(REGULAR_WORKSHOPS)) type = REGULAR_WORKSHOPS;
    if (pathName.includes("adminpanel/approve_workshop")) {
      type = "APPROVE";
      hideFilter = true;
    }
    if (pathName.includes("adminpanel/approve_module")) {
      type = "APPROVE_MODULE";
      hideFilter = true;
    }

    this.setState({
        type: type,
        title: "",
        pathname: pathName,
        hideFilter,
      },
      () => {this.loadNewByUrl("");
    });
  };

  handleChangeTitle = newTitle => {
    this.setState({ title: newTitle });
  };

  componentWillUnmount = () => {
    this.routerListener();
  };

  handleDelete = id => {
    this.setState({ modalOpened: true, delelteObject: id });
  };

  closeIcon = () => {
    this.setState({ title: "" }, () => {
      this.props.searchFieldEventEmitter.activate();
    });
  };

  deleteObject = () => {
    new HttpClient().delete(DELETE + this.state.delelteObject).then(data => {
      let elements = _.assign([], this.state.workshops);
      let index = elements.findIndex(el => el.id === this.state.delelteObject);
      elements.splice(index, 1);
      this.setState({
        workshops: elements,
        deleteObject: null,
        modalOpened: false
      });
      this.props.alert.success("This Workshop has been deleted.");
    });
  };

  decline = () => {
    this.setState({ modalOpened: false, deleteObject: null });
  };

  updateWorkshopFromList =(newWorkshop) => {
    this.setState({
      ...this.state,
      workshops: this.state.workshops.map((workshop) =>
        workshop.id != newWorkshop.id ? workshop : newWorkshop
      )
    })
  }

  isOrganizationType = state => {
    return state && state.organizations;
  }

  navigateToOrganizationsInfo = () => {
    this.props.history.push('/organisations-info');
  }

  closeLiveBanner = () => this.setState({showLiveBanner: false});
  closeOnlineBanner = () => this.setState({showOnlineBanner: false});
  closeGroupBanner = () => this.setState({showGroupBanner: false});
  closeOrgBanner = () => this.setState({showOrgBanner: false});
  closePublicBanner = () => this.setState({showPublicBanner: false});

  render() {
    const {hideFilter, showLiveBanner, showOnlineBanner, showGroupBanner, showOrgBanner, showPublicBanner} = this.state;
    const {location, modal, user: userProp, match} = this.props;
    const { updateComponent } = modal;
    const user = userProp.getUser();
    const isMyOnlineWorkshop = match.url.includes('/provider_my_workshops');
    const isOrganizations = location.search.includes('workshop_types[]=4') || this.isOrganizationType(location.state);
    const locationState = location.state || {};

    return (
      <main className="main-content purchased">
        <Modal
          isOpen={this.state.modalOpened}
          closeTimeoutMS={100}
          contentLabel="Modal"
        >
          <h1>Are you sure you want to delete this Workshop?</h1>
          <div className="modal-permissions-button">
            <div className="workshop-creator-sidebar-publish">
              <span className="btn prime bordered" onClick={this.deleteObject}>
                Accept
              </span>
            </div>
            <div
              className="workshop-creator-sidebar-publish"
              style={{ marginLeft: 15 }}
            >
              <span className="btn prime bordered red" onClick={this.decline}>
                Decline
              </span>
            </div>
          </div>
        </Modal>

        {!user && showLiveBanner && locationState.webinar && (
          <div className="organizations-banner">
            <p className="organizations-banner-text">Continue your professional development online with a range of live interactive webinars provided by accredited practitioners. Build your CPD hours online today.</p>
            <span className="close_banner_button" onClick={this.closeLiveBanner}>x</span>
          </div>
        )}

        {!user && showOnlineBanner && locationState.online && (
          <div className="organizations-banner">
            <p className="organizations-banner-text">Continue your professional development online with a range of online workshops and courses provided by accredited practitioners. Build your CPD hours online today.</p>
            <span className="close_banner_button" onClick={this.closeOnlineBanner}>x</span>
          </div>
        )}

        {!user && showGroupBanner && locationState.group && (
          <div className="organizations-banner">
            <p className="organizations-banner-text">Live Public Webinars hosted by mental health experts.</p>
            <span className="close_banner_button" onClick={this.closeGroupBanner}>x</span>
          </div>
        )}

        {!user && showPublicBanner && locationState.public && (
          <div className="organizations-banner">
            <p className="organizations-banner-text">Public workshops developed by mental health experts. Access high quality workshops at a time and place that suits you.</p>
            <span className="close_banner_button" onClick={this.closePublicBanner}>x</span>
          </div>
        )}

        {!user && showOrgBanner && locationState.organizations && (
          <div className="organizations-banner">
            <p className="organizations-banner-text">Therapy Academy Organisation training courses are delivered online and can be tailored to your specific needs. Our experienced course providers can facilitate training over a broad range of topics.</p>
            <span
              className="add-workshop nav-btn btn prime bordered"
              onClick={this.navigateToOrganizationsInfo}
            >
                Click here for more info
            </span>
            <span className="close_banner_button" onClick={this.closeOrgBanner}>x</span>
          </div>
        )}
        <div className="container-fluid workshop-list dashboard">
          <div
            style={isOrganizations ? {
              display: 'flex',
              flexDirection: 'row',
            } : {}}
          >
            <SearchField
              submitFilter={this.loadNewByUrl}
              count={this.state.count}
              value={this.state.title}
              defaultPrefix={this.state.defaultPrefix}
              handleChangeTitle={this.handleChangeTitle}
              closeIcon={this.closeIcon}
              style={isOrganizations ? {
                flex: '1',
                display: 'flex',
                alignItems: 'flex-end',
                marginRight: '16px',
              } : {}}
            />
            {isOrganizations &&
              <OrganizationFilter
                handleSubmit={this.loadNewByUrl}
              />
            }
          </div>
          <StickyContainer className="row">
            <div className="col-12 col-md-3">
              {user ?  (user.role != 'trainee' && isMyOnlineWorkshop && <MyOnlineWorkshopsCert />) : null}
              {window.innerWidth > 767 ? (
                <Sticky>
                  {({ style }) => (
                    <MyWorkShopFilters
                      hideFilter={hideFilter || isOrganizations}
                      submitFilter={this.loadNewByUrl}
                      title={this.state.title}
                      count={this.state.count}
                      defaultPrefix={this.state.defaultPrefix}
                      style={style}
                    />
                  )}
                </Sticky>
              ) : (
                <MyWorkShopFilters
                  hideFilter={hideFilter || isOrganizations}
                  submitFilter={this.loadNewByUrl}
                  title={this.state.title}
                  count={this.state.count}
                  defaultPrefix={this.state.defaultPrefix}
                />
              )}
            </div>
            <div className={`col-12 ${hideFilter || isOrganizations ? '' : 'col-md-9'}`}>
              <div className="section-holder workshop-card-holder" style={hideFilter || isOrganizations ? {width: '100%'} : {}}>
                <div
                  className="section-holder-inner"
                  style={{ position: "relative", minHeight: 300 }}
                >
                  {this.state.workshops.length === 0 && (
                    <div
                      style={{ position: "absolute", top: "40%", left: "50%" }}
                    >
                      <div
                        style={{
                          backgroundColor: "#ebebeb",
                          width: 64,
                          height: 64,
                          borderRadius: "50%",
                          marginLeft: -32
                        }}
                      >
                        <img
                          src={EMPTY}
                          alt=""
                          style={{ marginLeft: 21.5, marginTop: 22 }}
                        />
                      </div>
                      <p
                        style={{
                          opacity: 0.87,
                          width: 300,
                          marginLeft: -150,
                          fontSize: 20,
                          marginTop: 10,
                          lineHeight: 1.25,
                          textAlign: "center",
                          letterSpacing: 0.1,
                          color: "rgba(0, 0, 0, 0.54)"
                        }}
                      >
                        There are no Workshops matching your chosen criteria.
                      </p>
                    </div>
                  )}

                  {this.state.workshops.map(el => {
                    if (el.workshop_type === "online" || el.workshop_type === "live" || el.workshop_type === 'group_supervision' || el.workshop_type === 'organization' || el.workshop_type === 'public_workshop')
                      return (
                        <OnlineWorkShop
                          type={this.state.type}
                          workshop={el}
                          key={el.id}
                          handleDelete={this.handleDelete}
                          isWebinar={el.workshop_type === "live" || el.workshop_type === 'group_supervision' || el.workshop_type === 'organization'}
                        />
                      );
                    if (el.workshop_type === "in_person")
                      return (
                        <RegularWorkshop
                          type={this.state.type}
                          workshop={el}
                          key={el.id}
                          handleDelete={this.handleDelete}
                          updateWorkshopFromList={this.updateWorkshopFromList}
                        />
                      );
                  })}
                  {this.state.isLoading && (
                    <div className="spinner-container">
                      <ClipLoader color='#00BFFF' loading={this.state.isLoading} size={150} />
                    </div>
                  )}
                </div>
                {this.state.count ? <Pagination /> : null}
              </div>
            </div>
          </StickyContainer>
        </div>
      </main>
    );
  }
}

export default MyWorkshops;



// WEBPACK FOOTER //
// ./src/components/providers/MyWorkshops.jsx